/* Project specific Javascript goes here. */
import tippy from 'tippy.js';

/*————————————————————————————————————————————————————*\
    ●❱ ANIMATIONS
\*————————————————————————————————————————————————————*/

let slideUp = (target, duration = 500) => {
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    }, duration);
};
let slideDown = (target, duration = 500) => {
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;

    if (display === "none") display = "block";

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(() => {
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    }, duration);
};

let slideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === "none") {
        return slideDown(target, duration);
    } else {
        return slideUp(target, duration);
    }
};

function toggle_attr_expand(element) {

    if (element.getAttribute("aria-expanded") === "true") {
        element.setAttribute("aria-expanded", "false");
        element.parentElement.classList.remove('activo');
    } else {
        element.setAttribute("aria-expanded", "true");
        element.parentElement.classList.add('activo');
    }
}

/*————————————————————————————————————————————————————*\
    ●❱ MENU RESPONSIVE
\*————————————————————————————————————————————————————*/
const check_menu = document.getElementById('menu-toggle');
const menu__responsive = document.getElementById('menu__responsive');

if (check_menu) {
    check_menu.addEventListener('change', () => {
        if (check_menu.checked) {
            menu__responsive.classList.add('menu_active');
        }
        else {
            menu__responsive.classList.remove('menu_active');
        }
    });
}

/*————————————————————————————————————————————————————*\
    ●❱ FREQUENTLY QUESTIONS ALL ACCORDIONS
\*————————————————————————————————————————————————————*/

const questions_btn = document.querySelectorAll(".accordion__block--question");

if (questions_btn) {
    questions_btn.forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            toggle_attr_expand(el);
            el.classList.toggle("active");
            slideToggle(el.nextElementSibling, 600);
        })
    })
}

const climate__risk_accordion = document.querySelectorAll(".climate__risk_accordion");

if (climate__risk_accordion) {
    climate__risk_accordion.forEach(function (el) {
        el.addEventListener('click', function (e) {
            e.preventDefault();
            toggle_attr_expand(el);
            el.classList.toggle("active");
            slideToggle(el.nextElementSibling, 600);
        })
    })
}

const recommended_btn = document.querySelector('.recommendationButton');
const recommended_content = document.querySelector('#recommendationContent');
if (recommended_content && recommended_btn) {
    recommended_btn.addEventListener('click', (e) => {
        e.preventDefault();
        toggle_attr_expand(recommended_btn);
        recommended_btn.classList.toggle("active");
        slideToggle(recommended_content, 600);
    })
}

/*————————————————————————————————————————————————————*\
    ●❱ TOOLTIPS
\*————————————————————————————————————————————————————*/

const initializeTooltip = (selector, content, event=null, position=null) => {
    if (!event) {
        event='mouseenter';
    }

    const props = {
        content: content,
        theme: 'light-border',
        arrow: true,
        animation: 'scale',
        trigger: event,
        allowHTML: true,
    }

    if (position){
        props['placement'] = position;
    }

    tippy(selector, props);
}

window.initializeTooltip = initializeTooltip;

let all_aptitud_legend = document.querySelectorAll('.apt_legend');
let all_aptitudftr_legend = document.querySelectorAll('.aptftr_legend');
let all_gradient_legend = document.querySelectorAll('.gradient_legend');

if (all_aptitud_legend) {
    all_aptitud_legend.forEach((e, i) => {
        tippy(all_aptitud_legend[i], {
            content: all_aptitud_legend[i].getAttribute('data-tooltip'),
            theme: 'brown',
        });
    });
}

if (all_aptitudftr_legend) {
    all_aptitudftr_legend.forEach((e, i) => {
        tippy(all_aptitudftr_legend[i], {
            content: all_aptitudftr_legend[i].getAttribute('data-tooltip'),
            theme: 'brown',
        });
    });
}

if (all_gradient_legend) {
    all_gradient_legend.forEach((e, i) => {
        tippy(all_gradient_legend[i], {
            content: all_gradient_legend[i].getAttribute('data-tooltip'),
            theme: 'brown',
        });
    });
}

/*————————————————————————————————————————————————————*\
    ●❱ FORM SUBMIT
\*————————————————————————————————————————————————————*/
function submitForm(formId) {
    const form = document.getElementById(formId);
    const data = new FormData(form);
    const loadingIndicator = document.getElementById('loadingIndicator');
    const csrftoken = document.getElementsByName('csrfmiddlewaretoken')[0].value;

    loadingIndicator.style.display = 'block';
    fetch(form.action, {
        method: 'POST',
        body: data,
        headers: {
            'X-CSRFToken': csrftoken,
        },
        credentials: 'same-origin'
    }).then(response => {
        if (response.ok){
            window.location.reload();
        }
    }).catch(error => console.error('Error:', error));
}

window.submitForm = submitForm;
